export var navbar = function (value) { return [
    {
        id: 5,
        title: value.navbar.media,
        value: 'media',
        href: '/media',
        type: 'vira'
    },
    {
        id: 1,
        title: value.navbar.services,
        value: 'services',
        href: '/services',
        type: 'vira'
    },
    {
        id: 2,
        title: value.navbar.works,
        value: 'works',
        href: '/works',
        type: 'vira'
    },
    {
        id: 3,
        title: value.navbar.tech,
        value: 'tech',
        href: '/tech',
        type: 'vira'
    },
    {
        id: 4,
        title: value.navbar.aboutUs,
        value: 'aboutUs',
        href: '/aboutus',
        type: 'vira'
    },
    {
        id: 6,
        title: value.navbar.mrEstateIntro,
        value: 'mrestate-intro',
        href: '/mrestate-intro',
        type: "mrestate"
    },
    {
        id: 7,
        title: value.navbar.mrEstateFeatures,
        value: 'mrestate-features',
        href: '/mrestate-features',
        type: "mrestate"
    },
    {
        id: 8,
        title: value.navbar.mrEstateMonetization,
        value: 'mrestate-monetization',
        href: '/mrestate-monetization',
        type: "mrestate"
    },
]; };
